import { InfoTooltip } from '@karnov/kui-react'
import { FC } from 'react'

import { MessageResourceTagClickEventWrapper } from 'components/MessageResourceTag/MessageResourceTagClickEventWrapper'
import { MessageResourceTagLayoutWrapper } from 'components/MessageResourceTag/MessageResourceTagLayoutWrapper'
import { RemoveMessageResourceButton } from 'components/MessageResourceTag/RemoveMessageResourceButton'
import { AttachmentWithUploadStatus } from 'types/AttachmentWithUploadStatus'

import { AttachmentIconAndStatus } from './AttachmentIconAndStatus'
import { AttachmentInfo } from './AttachmentInfo'
import { AttachmentPopover } from './AttachmentPopover'

type Props = {
  attachment: AttachmentWithUploadStatus
  isDetailedView?: boolean
  onClickAttachment?: VoidFunction
  onRemoveAttachment?: (attachmentId: number) => void
}

export const Attachment: FC<Props> = ({ attachment, isDetailedView, onClickAttachment, onRemoveAttachment }) => {
  const isPending = attachment.status === 'deleting' || attachment.status === 'uploading'

  return (
    <InfoTooltip content={<AttachmentPopover attachment={attachment} />} disabled={isDetailedView} side="top">
      <div>
        <MessageResourceTagClickEventWrapper onClick={onClickAttachment} resourceType="attachment">
          <MessageResourceTagLayoutWrapper
            status={attachment.status}
            isDetailedView={isDetailedView}
          >

            <AttachmentIconAndStatus
              attachmentStatus={attachment.status}
              contentType={attachment.contentType}
              isDetailedView={isDetailedView}
              isPending={isPending}
            />

            <div className="flex-grow">
              <AttachmentInfo
                capacityUsage={attachment.capacityUsage}
                contentType={attachment.contentType}
                errorType={attachment.errorType}
                filename={attachment.filename}
                isDetailedView={isDetailedView}
                isPending={isPending}
              />
            </div>

            {onRemoveAttachment && (
              <RemoveMessageResourceButton
                isDisabled={isPending}
                onClick={() => onRemoveAttachment(attachment.id)}
                resourceType="attachment"
              />
            )}
          </MessageResourceTagLayoutWrapper>
        </MessageResourceTagClickEventWrapper>
      </div>
    </InfoTooltip>
  )
}
